import "./app.scss";

import { QueryClient, QueryClientProvider } from "react-query";

import { AppRoutes } from "./app.routes";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "components/error-fallback";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

const queryClient = new QueryClient();

const App: React.FC = () => {
	return (
		<div className="app" data-testid="app">
			<ErrorBoundary FallbackComponent={ErrorFallback}>
				<QueryClientProvider client={queryClient}>
					<Router>
						<AppRoutes />
					</Router>
				</QueryClientProvider>
			</ErrorBoundary>
		</div>
	);
};

export default App;
